import { useMainContext } from '@upright/ui/views/root/main/context';
import { AboutModalContentOrMobileFooter } from '../../../common/generic/components/about-modal-content-or-mobile-footer';
import { MobileOnly } from '../../../common/generic/layout/breakpoint-utils';
import { isScreenshotMode } from '../../../common/generic/utilities/debug-mode';

export function FooterMaybe() {
  const [, setContactModalOpen] = useMainContext().contactModal;

  if (isScreenshotMode()) {
    return <></>;
  }
  return (
    <>
      <MobileOnly style={{ flexShrink: 0, flexGrow: 0 }}>
        <AboutModalContentOrMobileFooter
          onContactLinkPress={() => {
            setContactModalOpen(true);
          }}
        />
      </MobileOnly>
    </>
  );
}
